import { Component, Inject } from '@angular/core';

import { MatBottomSheetRef, MAT_BOTTOM_SHEET_DATA } from '@angular/material/bottom-sheet';
import { MatIconModule } from '@angular/material/icon';
import { TranslocoModule } from '@jsverse/transloco';
import { Team } from '../../../interfaces/database/team.interface';
import { TEAM_COLOR_CLASS } from '../../../core/services/team-context.utils';

export interface TeamPickerSheetData {
    teams: Team[];
    selectedId: string;
}

@Component({
    selector: 'ph-team-picker-sheet',
    standalone: true,
    imports: [MatIconModule, TranslocoModule],
    templateUrl: './team-picker-sheet.component.html',
})
export class TeamPickerSheetComponent {
    readonly allTeams: Team[];
    readonly selectedId: string;

    constructor(
        private _ref: MatBottomSheetRef<TeamPickerSheetComponent>,
        @Inject(MAT_BOTTOM_SHEET_DATA) data: TeamPickerSheetData,
    ) {
        this.selectedId = data.selectedId;
        this.allTeams = data.teams;
    }

    teamColorClass(team: Team): string {
        return TEAM_COLOR_CLASS[team.colorKey] ?? TEAM_COLOR_CLASS['blue'];
    }

    select(id: string): void {
        this._ref.dismiss(id);
    }
}
